// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"4bf00dd1","361":"8461d00b","700":"d0f8283c","879":"9b0d0842","976":"e2886e26"}[chunkId] + ".chunk.js";
};